import React from 'react';

import './Contact.css'
import {
    CONTACT_EMAIL,
    LIMITS,
    RECAPTCHA_ACTION,
    RECAPTCHA_SITE_KEY,
    buildPayload,
    submitContact,
    validateContact
} from './contactService';
import {executeRecaptcha, loadRecaptcha} from './recaptcha';

const EMPTY_FORM = {
    name: '',
    email: '',
    phone: '',
    message: '',
    website: ''
};

const FIELD_ORDER = ['name', 'email', 'phone', 'message'];

const CAPTCHA_FAILURE = "La vérification anti-spam n'a pas pu être effectuée. Vérifiez votre connexion "
    + "(ou désactivez un éventuel bloqueur de contenu pour ce site) puis réessayez, ou écrivez-nous à "
    + CONTACT_EMAIL + '.';

class Contact extends React.Component {
    /**
     *
     * @param props
     */
    constructor(props) {
        super(props);
        this.state = {
            ...EMPTY_FORM,
            fieldErrors: {},
            formError: null,
            submitting: false,
            submitted: false,
            successMessage: ''
        };
        this.mounted = false;
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.hideMessage = this.hideMessage.bind(this);
    }

    componentDidMount() {
        this.mounted = true;
        // reCAPTCHA v3 est chargé dès l'affichage pour observer la navigation ; un
        // échec ici est retenté au moment de l'envoi.
        loadRecaptcha(RECAPTCHA_SITE_KEY).catch(error => console.warn(error));
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    formValues() {
        const {name, email, phone, message, website} = this.state;
        return {name, email, phone, message, website};
    }

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.submitting) {
            return;
        }
        const values = this.formValues();

        const fieldErrors = validateContact(values);
        if (Object.keys(fieldErrors).length > 0) {
            this.setState({fieldErrors, formError: 'Merci de corriger les champs signalés.'});
            this.focusFirstError(fieldErrors);
            return;
        }

        this.setState({submitting: true, fieldErrors: {}, formError: null});

        let token;
        try {
            // Un jeton neuf à chaque envoi : il n'est valable qu'une fois et deux minutes.
            token = await executeRecaptcha(RECAPTCHA_SITE_KEY, RECAPTCHA_ACTION);
        } catch (error) {
            console.warn(error);
            if (this.mounted) {
                this.setState({submitting: false, formError: CAPTCHA_FAILURE});
            }
            return;
        }
        if (!this.mounted) {
            return;
        }

        const result = await submitContact(buildPayload(values, token));
        if (!this.mounted) {
            return;
        }

        if (result.ok) {
            this.setState({
                ...EMPTY_FORM,
                fieldErrors: {},
                formError: null,
                submitting: false,
                submitted: true,
                successMessage: result.message
            });
            return;
        }

        // En cas d'erreur, la saisie est conservée.
        this.setState({
            submitting: false,
            fieldErrors: result.fieldErrors || {},
            formError: result.message
        });
        this.focusFirstError(result.fieldErrors || {});
    }

    focusFirstError(fieldErrors) {
        const field = FIELD_ORDER.find(name => fieldErrors[name]);
        if (field) {
            const element = document.getElementById('contact-' + field);
            if (element && typeof element.focus === 'function') {
                element.focus();
            }
        }
    }

    handleChange(event) {
        const name = event.target.name;
        const value = event.target.value;
        const fieldErrors = {...this.state.fieldErrors};
        delete fieldErrors[name];
        this.setState({[name]: value, fieldErrors});
    }

    hideMessage(event) {
        event.preventDefault();
        this.setState({
            submitted: false,
            successMessage: ''
        });
    }

    fieldProps(name) {
        const error = this.state.fieldErrors[name];
        return {
            id: 'contact-' + name,
            name,
            value: this.state[name],
            onChange: this.handleChange,
            className: error ? 'error' : undefined,
            'aria-invalid': error ? true : undefined,
            'aria-describedby': error ? 'contact-' + name + '-error' : undefined
        };
    }

    fieldError(name) {
        const error = this.state.fieldErrors[name];
        return error ?
            <label className="error" id={'contact-' + name + '-error'} htmlFor={'contact-' + name}>{error}</label> :
            null;
    }

    render() {
        const {submitting, formError} = this.state;
        return (
            <>
                {!this.state.submitted ? <div className="auto-container">
                        <div className="inner-container">

                            <div className="sec-title text-center">
                                <h2>Notre <span className="normal-font">Contact</span></h2>
                            </div>

                            <div className="contact-info row clearfix">
                                <div className="info-column col-lg-4 col-md-6 col-xs-12">
                                    <div className="inner-box">
                                        <div className="icon"><span className="flaticon-location"/></div>
                                        <h4>ADDRESS</h4>
                                        6 Impasse Jean Moulin,<br/>
                                        92390 Villeneuve-la-Garenne
                                    </div>
                                </div>
                                <div className="info-column col-lg-4 col-md-6 col-xs-12">
                                    <div className="inner-box">
                                        <div className="icon"><span className="flaticon-technology"/></div>
                                        <h4>Phone</h4>
                                        0620790921
                                    </div>
                                </div>
                                <div className="info-column col-lg-4 col-md-6 col-xs-12">
                                    <div className="inner-box">
                                        <div className="icon"><span className="flaticon-interface"/></div>
                                        <h4>Email</h4>
                                        <a href="mailto:association@barinta.org">association [at] barinta [dot] org</a>,
                                    </div>
                                </div>
                            </div>

                            <div className="contact-form-container wow zoomInStable animated c-animation"
                                 data-wow-delay="0ms"
                                 data-wow-duration="2500ms">
                                <form method="post" action="" id="contact-form" noValidate={true}
                                      onSubmit={this.handleSubmit}>
                                    <div className="row clearfix">
                                        {formError &&
                                        <div className="column col-md-12 col-sm-12 col-xs-12">
                                            <p className="contact-form-error" role="alert">{formError}</p>
                                        </div>}
                                        <div className="column col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <input type="text" {...this.fieldProps('name')}
                                                       placeholder="Nom complet" aria-label="Nom complet"
                                                       autoComplete="name" maxLength={LIMITS.name}
                                                       required={true}/>
                                                {this.fieldError('name')}
                                            </div>
                                            <div className="form-group">
                                                <input type="email" {...this.fieldProps('email')}
                                                       placeholder="Email" aria-label="Email"
                                                       autoComplete="email" required={true}/>
                                                {this.fieldError('email')}
                                            </div>

                                            <div className="form-group">
                                                <input type="tel" {...this.fieldProps('phone')}
                                                       placeholder="Téléphone" aria-label="Téléphone"
                                                       autoComplete="tel" maxLength={LIMITS.phone}/>
                                                {this.fieldError('phone')}
                                            </div>
                                        </div>

                                        <div className="column col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <textarea {...this.fieldProps('message')}
                                                          placeholder="Message" aria-label="Message"
                                                          maxLength={LIMITS.messageMax} required={true}/>
                                                {this.fieldError('message')}
                                            </div>
                                        </div>

                                        {/* Champ piège invisible : seuls les robots le remplissent. */}
                                        <div className="contact-form-trap" aria-hidden="true">
                                            <label htmlFor="contact-website">Ne pas remplir ce champ</label>
                                            <input type="text" id="contact-website" name="website"
                                                   value={this.state.website} onChange={this.handleChange}
                                                   tabIndex={-1} autoComplete="off"/>
                                        </div>

                                        <div className="column col-md-12 col-sm-12 col-xs-12">

                                            <div className="column col-md-6 col-sm-12 col-xs-12">
                                                {/* Mention obligatoire : le badge reCAPTCHA est masqué (Contact.css). */}
                                                <p className="recaptcha-notice">
                                                    Ce site est protégé par reCAPTCHA : les{' '}
                                                    <a href="https://policies.google.com/privacy" target="_blank"
                                                       rel="noopener noreferrer">règles de confidentialité</a> et les{' '}
                                                    <a href="https://policies.google.com/terms" target="_blank"
                                                       rel="noopener noreferrer">conditions d'utilisation</a> de
                                                    Google s'appliquent.
                                                </p>
                                            </div>

                                            <div className="form-group col-md-6 col-xs-12">
                                                <button type="submit" name="submit" disabled={submitting}
                                                        className={'theme-btn btn-style-two c-theme-btn' + (submitting ? ' spin' : '')}>
                                                    Envoyer <span className={(submitting ? ' spinner' : '')}/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div> :
                    <div className="auto-container">
                        <div className="sec-title">
                            <h1>Merci pour votre message</h1>
                            {this.state.successMessage &&
                            <p className="contact-form-success" role="status">{this.state.successMessage}</p>}
                            <h2><a href="/#" onClick={this.hideMessage}>OK</a></h2>
                        </div>
                    </div>
                }
            </>
        );
    }
}

export default Contact;
